module.exports = "<div> {% if (link) { %} <a href={%- link %} class=q-boldest><span>{%- content %}</span></a> {% } else { %} <span>{%- content %}</span> {% } %} </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/defaultDesktopHtml.html
// module id = 1146
// module chunks = 1